import { createContext, useContext, useState, useEffect } from "react";
import { setLoader } from "../utils/SiteLoaderHandler";
import SiteLoader from "../components/Common/SiteLoader";

const LoaderContext = createContext();

export const useLoader = () => useContext(LoaderContext);

export const LoaderProvider = ({ children }) => {

    const [loading, setLoading] = useState(false);

    const show = () => {
        setLoading(true);
    };

    const hide = () => {
        setTimeout(() => {
            setLoading(false);
        }, 300);
    };

    useEffect(() => {
        setLoader({
            show,
            hide
        });
    }, []);

    return (
        <LoaderContext.Provider value={{ show, hide }}>
            {loading && <SiteLoader />}
            {children}
        </LoaderContext.Provider>
    );
};